import React, { useState } from "react";
import Form from "olive-react-myoneui/lib/Form";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../../constants/config";
import { crossIcon } from "../../../constants/icons";

function SearchCourseBlock(props) {
  const { t } = useTranslation(commonModuleName);
  let searchTimer;
  const location = useLocation();
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const { className, children } = props;

  const inputSearch = () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      submitSearch();
    }, 1000);
  };

  const getChildren = (children) => {
    if ( children && children.length == undefined) {
      return [children];
    } else if (children && children.length > 1) {
      return children;
    } else {
      return [];
    }
  };

  const filteredChildren = getChildren(children).filter((child) => {
    const title = child.props.title.toLowerCase();
    const search = searchInput.toLowerCase();
    return title.includes(search);
  });

  const handleInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const clearSearch = () => {
    setSearchInput("");
    let currentURLSearch = new URLSearchParams(location.search);
    currentURLSearch.delete("search");
    navigate(`/course/listing?${currentURLSearch.toString()}`);
  };

  const submitSearch = (e = null) => {
    if (e) {
      e.preventDefault();
    }
    setTimeout(() => {
      if (searchInput === "") {
        clearSearch();
        return false;
      }
      let currentURLSearch = new URLSearchParams(location.search);
      currentURLSearch.set("search", searchInput);
      navigate(`/course/listing?${currentURLSearch.toString()}`);
    }, 500);
  };

  return (
    <div className={`${className || ""} search-course-block`}>
      <Form.Group className="search-wrapper" controlId="searchId">
        <Form onSubmit={(e) => submitSearch(e)}>
          <Form.Control
            type="search"
            placeholder={t("Search Course") + "..."}
            autoComplete="off"
            value={searchInput}
            onChange={handleInputChange}
            className="custom-search-input"
          />
          <span className="btn-clear" onClick={clearSearch}>
            {crossIcon}
          </span>
        </Form>
      </Form.Group>
      <h1>Results ({filteredChildren.length})</h1>
      <div className="search-course-list-wrap">
        {filteredChildren.map((child, index) => (
          <React.Fragment key={index}>{child}</React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default SearchCourseBlock;
